import { render, staticRenderFns } from "./RegulatoryUpdateFiscalInfo.vue?vue&type=template&id=bf78baa8&scoped=true"
import script from "./RegulatoryUpdateFiscalInfo.vue?vue&type=script&lang=ts"
export * from "./RegulatoryUpdateFiscalInfo.vue?vue&type=script&lang=ts"
import style0 from "./RegulatoryUpdateFiscalInfo.vue?vue&type=style&index=0&id=bf78baa8&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf78baa8",
  null
  
)

export default component.exports